import React, { useState } from 'react'

import { useEffect, useContext } from 'react'

import Select from 'react-select'

import mobGifList from '../../../../data/Monsters/npcidentity.json'

import { DBContext } from '../../../../contexts/databases'
import { UIContext } from '../../../../contexts/ui'
import { CharacterContext } from '../../../../contexts/character'

import './monsterWindow.scss'

function MonsterWindow(props) {
	const { monster_db, monster_dbReady } = useContext(DBContext)
	const { customStyles } = useContext(UIContext)
	const { searchAndSetOptions } = useContext(CharacterContext)
	const [options, setOptions] = useState([])
	const [currentValue, setCurrentValue] = useState({})
	const [currentMob, setCurrentMob] = useState(Number(0))
	try {
		useEffect(() => {
			let newOptions = []
			if (monster_dbReady) {
				// console.log(monster_db)
				monster_db.forEach((mob, index) => {
					newOptions.push({
						value: mob.Id,
						label: mob.Name,
						key: 'mob' + mob.Id,
					})
				})
				setOptions(newOptions)
				setCurrentValue({
					value: 1002,
					label: 'Poring',
					key: 'mob1002',
				})
			}
		}, [monster_db, monster_dbReady])
	} catch (e) {
		console.log(e)
	}
	useEffect(() => {
		if (monster_dbReady)
			setCurrentMob(
				monster_db.find((monster) => monster.Id === currentValue.value),
			)
	}, [currentValue, monster_db, monster_dbReady])
	useEffect(() => {
		if (currentMob) {
			props.onMonsterSelect(currentMob)
			// console.log(currentMob)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentMob])
	return (
		<div className={'monsterWindow'}>
			<div className='monsterWindowHorizontal2'>
				<Select
					menuPlacement='auto'
					value={currentValue}
					styles={customStyles}
					onChange={(event) => {
						setCurrentMob(
							monster_db.find(
								(monster) => monster.Id === event.value,
							),
						)
						searchAndSetOptions(
							options,
							event.value,
							setCurrentValue,
						)
						// console.log(
						// 	monster_db.find(
						// 		(monster) => monster.Id === event.value,
						// 	),
						// )
						// props.onMonsterSelect(
						// 	monster_db.find(
						// 		(monster) => monster.Id === event.value,
						// 	),
						// )
					}}
					options={options}
				/>
			</div>
			{monster_dbReady ? (
				<div className='monsterWindowHorizontal'>
					<div className='imageDiv'>
						<img
							src={
								'https://images.roprime-simulator.com/npc/' +
								(mobGifList[currentMob?.Id]
									? mobGifList[currentMob.Id].toLowerCase()
									: 'null') +
								'.gif'
							}
							alt={currentMob?.Name}
						></img>
						{/* </div> */}
					</div>
					<div className='monsterWindowVertical'>
						<div>Level : {currentMob?.Level}</div>
						<div>HP : {currentMob?.Hp}</div>
						<div>Size : {currentMob?.Size}</div>
						<div>Race : {currentMob?.Race}</div>
						<div>
							Ele. : {currentMob?.Element}{' '}
							{currentMob?.ElementLevel}
						</div>
						<div>
							Def: {currentMob?.Defense ?? 0} +{' '}
							{Math.floor(
								(currentMob?.Vit
									? currentMob.Vit
									: 1 + currentMob?.Level) / 2,
							)}
						</div>

						<div>
							Mdef: {currentMob?.MagicDefense ?? 0} +{' '}
							{Math.floor(
								(currentMob?.Level ? currentMob.Level : 1) / 4,
							) +
								Math.floor(
									(currentMob?.VIT ? currentMob.Vit : 1) / 10,
								) +
								Math.floor(
									(currentMob?.INT ? currentMob.Int : 1) / 5,
								)}
						</div>
					</div>
				</div>
			) : (
				'loading db'
			)}

			<div className={'monsters ' + props.className}></div>
		</div>
	)
}

export default MonsterWindow
